import { useEffect, useRef, useState } from 'react';

const FEEDBACK_MS = 2400;

export const useCopyToClipboard = (labels: { idle: string; copied: string; fallback: string }) => {
  const [label, setLabel] = useState(labels.idle);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timer.current != null) clearTimeout(timer.current);
    },
    [],
  );

  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setLabel(labels.copied);
    } catch {
      setLabel(labels.fallback);
    }
    if (timer.current != null) clearTimeout(timer.current);
    timer.current = setTimeout(() => setLabel(labels.idle), FEEDBACK_MS);
  };

  return { label, copy };
};
